export function isDocumentConstructorPayload(
  payload: Record<string, unknown> | null | undefined
): boolean {
  if (!payload || typeof payload !== "object") {
    return false;
  }
  return "name" in payload && ("params" in payload || "process" in payload);
}
